import React, { useState, useContext } from "react";
import "./Navbar.css";
import logo from "../../assets/logo.png";
import { LanguageContext } from "../../context/LanguageContext";
import { useLocation, Link } from "react-router-dom";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { language, toggleLanguage } = useContext(LanguageContext);
  const location = useLocation();
  const currentPath = location.search;

  const getLinkClass = (targetPath) =>
    currentPath === `?to=${targetPath}` ? "nav-link active" : "nav-link";

  return (
    <nav className="navbar" dir={language === "ar" ? "rtl" : "ltr"}>
      <div className="navbar__left">
        <img src={logo} alt="Falcom Logo" className="navbar__logo" />
      </div>

      {/* Hamburger Icon */}
      <div
        className={`navbar__toggle ${menuOpen ? "open" : ""}`}
        onClick={() => setMenuOpen(!menuOpen)}
      >
        <span></span>
        <span></span>
        <span></span>
      </div>

      <ul className={`navbar__links ${menuOpen ? "active" : ""}`}>
        <li>
          <Link to="/r?to=about" className={getLinkClass("about")} onClick={() => setMenuOpen(false)}>
            {language === "ar" ? "من نحن" : "About Us"}
          </Link>
        </li>
        <li>
          <Link to="/r?to=announcements" className={getLinkClass("announcements")} onClick={() => setMenuOpen(false)}>
            {language === "ar" ? "الإعلانات" : "Announcements"}
          </Link>
        </li>
        <li>
          <Link to="/r?to=vision" className={getLinkClass("vision")} onClick={() => setMenuOpen(false)}>
            {language === "ar" ? "الرؤية" : "Vision"}
          </Link>
        </li>
        <li>
          <Link to="/r?to=companies" className={getLinkClass("companies")} onClick={() => setMenuOpen(false)}>
            {language === "ar" ? "الشركات" : "Companies"}
          </Link>
        </li>
        <li>
          <Link to="/r?to=board" className={getLinkClass("board")} onClick={() => setMenuOpen(false)}>
            {language === "ar" ? "مجلس الإدارة" : "Board of Directors"}
          </Link>
        </li>
        <li>
          <Link to="/r?to=investments" className={getLinkClass("investments")} onClick={() => setMenuOpen(false)}>
            {language === "ar" ? "الاستثمارات" : "Investments"}
          </Link>
        </li>
        <li>
          <Link to="/r?to=contact" className={getLinkClass("contact")} onClick={() => setMenuOpen(false)}>
            {language === "ar" ? "تواصل معنا" : "Contact Us"}
          </Link>
        </li>

        <li
          className="navbar__lang mobile"
          onClick={() => {
            toggleLanguage();
            setMenuOpen(false);
          }}
        >
          {language === "ar" ? "English" : "العربية"}
        </li>
      </ul>

      <button
        className="navbar__lang desktop"
        onClick={() => {
          toggleLanguage();
          setMenuOpen(false);
        }}
      >
        {language === "ar" ? "English" : "العربية"}
      </button>
    </nav>
  );
};

export default Navbar;
